import {createActionTypes, createActionCreators} from 'utils/reduxUtils';

const typesArray = [
    'REF_LIST_REVOKE_NOTIF_CLICK'
];

export const ActionTypes = createActionTypes(typesArray);
export const Actions = createActionCreators(typesArray);
